import React, { useCallback, useMemo } from 'react';
import { DropdownWithSearch } from 'components/core/DropdownWithSearch';
import { Option } from 'components/core/DropdownWithSearch/DropdownWithSearch.types';
import { AddressSearchProps, AddressOption } from './AddressSearch.types';
import { buildAddressOptions } from './AddressSearch.helper';
import * as Styled from './AddressSearch.styles';

const ADDRESS_OPTION_HEIGHT = 80;

const AddressSearch: React.FC<AddressSearchProps> = ({
  addresses,
  isLoading,
  selectedValue,
  onChange,
  placeholder = 'Select Shipping Address',
  width = '400px',
  height = 'auto',
  isClearable = true,
  background,
  excludedAddresses = [],
  hasError,
  size = 'md',
  noBorder = true,
  disabled = false,
  showAccountNumber = false,
}) => {
  const addressOptions = useMemo(
    () => buildAddressOptions(addresses, excludedAddresses),
    [addresses, excludedAddresses]
  );

  const formatAddressOption = useCallback(
    (option: Option) => {
      const addr = option as AddressOption;
      if (addr.accountName != null && addr.accountAddress != null) {
        return (
          <Styled.AddressWrapper>
            <Styled.AccountName>
              {addr.accountName}
              {showAccountNumber && (
                <span style={{ fontWeight: 400, color: 'rgba(0, 0, 0, 0.55)' }}>
                  {' '}({addr.value})
                </span>
              )}
            </Styled.AccountName>
            <Styled.AccountAddress>
              {addr.accountAddress}
            </Styled.AccountAddress>
          </Styled.AddressWrapper>
        );
      }
      return option.label;
    },
    [showAccountNumber]
  );

  return (
    <DropdownWithSearch
      options={addressOptions}
      selectedValue={selectedValue}
      onChange={onChange}
      placeholder={isLoading ? 'Loading addresses...' : placeholder}
      width={width}
      height={height}
      isClearable={isClearable}
      background={background}
      hasError={hasError}
      size={size}
      formatOptionLabel={formatAddressOption}
      optionHeight={ADDRESS_OPTION_HEIGHT}
      menuSearchable
      menuSearchPlaceholder="Search address..."
      noBorder={noBorder}
      disabled={disabled}
    />
  );
};

export default AddressSearch;
